<div *ngIf="modoEdicao && !emInclusao && temAmortizacoesAntecipadas">
  <div class="row">
    <div class="col-md-12">
        <div class="form-check text-end">
            <input type="checkbox" class="form-check-input" id="mostrarAmortizacoesAntecipadas" name="mostrarAmortizacoesAntecipadas" [(ngModel)]="mostrarAmortizacoesAntecipadas">
            <label class="form-check-label" for="mostrarAmortizacoesAntecipadas">Mostrar amortizações antecipadas</label>
          </div>
    </div>
  </div>
</div>

<div class="table-responsive" *ngIf="amortizacoes;else carregando">
  <table class="table table-hover">
    <thead>
      <tr>
        <th scope="col"></th>
        <th scope="col">Data da amortização <span style="color: #b00020;">*</span></th>
        <th scope="col" class="coluna-moeda">Valor da amortização <span style="color: #b00020;">*</span></th>
        <th scope="col" class="coluna-moeda" *ngIf="!modoEdicao && !emInclusao">Saldo devedor após a
          amortização</th>
      <tr>
    </thead>
    <tbody>
      <ng-container *ngIf="!modoEdicao && !emInclusao">
        <tr *ngFor="let amortizacao of amortizacoes; let i = index">
          <td>
            <span *ngIf="exibirBotaoCancelarAmortizacao(amortizacao)">
              <a bnConfirm tituloConfirm="Confirmação" msgConfirm="Cancelar amortização antecipada?"
                (onConfirm)="cancelarAmortizacaoAntecipada(amortizacao.id)" ngbTooltip="Cancelar amortização antecipada">
                <i class="fa fa-trash cursor-pointer"></i>
              </a>
            </span>
            <span *ngIf="!amortizacao.antecipada">
              {{ operacao.getNumeroAmortizacao(amortizacao) }}
            </span>
          </td>
          <td>
            <span>{{ amortizacao?.data | bnMask:'DD/MM/AAAA'}}{{amortizacao.antecipada ? " (antecipada)" : "" }}</span>
          </td>
          <td class="coluna-moeda">
            <span>{{ getValorAmortizacao(amortizacao?.valor) | bnMask:'MOEDA'}}</span>
          </td>
          <td class="coluna-moeda">{{amortizacao.saldoPosAmortizacao | bnMask:'MOEDA'}}</td>
        </tr>
      </ng-container>
      <ng-container *ngIf="modoEdicao || emInclusao">
        <tr *ngFor="let amortizacao of amortizacoes">
          <td *ngIf="mostrarAmortizacoesAntecipadas || !amortizacao.antecipada">
            <span><a (click)="removerAmortizacao(amortizacao.indice)" *ngIf="!amortizacao.antecipada"><i class="fa fa-trash cursor-pointer"></i></a></span>
          </td>
          <td *ngIf="mostrarAmortizacoesAntecipadas || !amortizacao.antecipada">
            <bn-datepicker [name]="nomeCampo('dataAmortizacao', amortizacao.indice)" [(ngModel)]="amortizacao.data" required [disabled]="amortizacao.antecipada">
            </bn-datepicker>
          </td>
          <td class="coluna-moeda" *ngIf="mostrarAmortizacoesAntecipadas || !amortizacao.antecipada">
            <input type="text" class="form-control" [name]="nomeCampo('valorAmortizacao', amortizacao.indice)"
              [(ngModel)]="amortizacao.valor" bnMask="MOEDA" [disabled]="amortizacao.antecipada" />
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
  <a (click)="adicionarAmortizacao()" *ngIf="modoEdicao || emInclusao"><i
      class="fa fa-plus-circle cursor-pointer"></i></a>
</div>


<ng-template #carregando>
  <div class="loading-pesquisa">
    <i class="bn-loading"></i>
  </div>
</ng-template>